import { CButton, CCard, CCardBody, CDropdownItem } from '@coreui/react-pro'
import React from 'react'

import CardDiagnosisProcedure from 'src/components/common/CardDiagnosisProcedure/CardDiagnosisProcedure'
import ProgressNoteActionButtons from './ProgressNoteActionButtons'
import { useSelector } from 'react-redux'
import FEATURES from '../../../utils/featuresConstants'
import { getIsAi } from '../../../utils/sharedFeaturesFunctions'

export default function BillingSummaryDisabled({
  onSaveDraft,
  onSignAndBill,
  visit,
  isValidToSign,
}) {
  const features = useSelector((state) => state?.user?.features)

  return (
    <CCard>
      <CCardBody className={'billsummary-card-body'}>
        <div className="billing-summary-holder">
          <div className="billing-summary">
            {/* cpt */}

            <div className="procedure-holder">
              <div className="ProcedureCard">
                <div className="ProceduredHeaderContainer">
                  <div className="ProcedureCardHeader">
                    <h5 className="card-title ProcedureCardTitle">Procedure Codes</h5>
                  </div>
                </div>
                <div className="Procedure-card-select-card">
                  <div className="proc-card-scroll mb-2">
                    {visit?.procedureCodes?.map((proceduredata, index) => (
                      <CardDiagnosisProcedure
                        key={index}
                        index={index}
                        item={proceduredata}
                        selectedList={visit?.procedureCodes}
                        type={'PROCEDURE'}
                        isBillingSummaryDisabled={true}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <div className="procedure-holder">
              <div className="ProcedureCard">
                <div className="ProceduredHeaderContainer">
                  <div className="ProcedureCardHeader">
                    <h5 className="card-title ProcedureCardTitle">Diagnosis Codes</h5>
                  </div>
                </div>
                <div className="Procedure-card-select-card">
                  <div className="proc-card-scroll mb-2">
                    {visit?.diagnosisCodes?.map((diagnosisdata, index) => (
                      <CardDiagnosisProcedure
                        key={index}
                        index={index}
                        item={diagnosisdata}
                        isBillSummary={true}
                        type={'DIAGNOSIS'}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {getIsAi() && features?.includes(FEATURES.DesktopAI) && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  height: '6rem',
                  alignItems: 'flex-end',
                }}
              >
                <div>
                  <ProgressNoteActionButtons
                    SignButton={() => (
                      <CButton
                        className="progress-note-billing-summary-dropdown-main"
                        color="primary"
                        onClick={onSignAndBill}
                        disabled={!isValidToSign}
                      >
                        Sign Note
                      </CButton>
                    )}
                    SaveButton={() => (
                      <CDropdownItem
                        className="progress-note-billing-summary-item progress-note-billing-summary-item-draft"
                        onClick={() => onSaveDraft()}
                      >
                        <div className="progress-note-billing-summary-item-text">Save as draft</div>
                      </CDropdownItem>
                    )}
                    PendingReviewButton={() => (
                      <CDropdownItem className="progress-note-billing-summary-item progress-note-billing-summary-item-pending-review">
                        <div
                          className="progress-note-billing-summary-item-text"
                          onClick={() => {
                            onSaveDraft(null, { isPendingReview: true })
                          }}
                        >
                          Pending review
                        </div>
                      </CDropdownItem>
                    )}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </CCardBody>
    </CCard>
  )
}
